import React from 'react'
import { AdminMenuItem } from '../AdminMenu'

export class ExportSvgMenuItem extends React.PureComponent {
  onClick = () => {
    document.getElementById('sampleGraph')
      .dispatchEvent(new Event('pleaseExportSVG')) //eslint-disable-line
  }

  render () {
    return <AdminMenuItem
      menuKey={'export_svg'}
      label='Export elevation SVG'
      onClick={() => this.onClick()} />
  }
}

export class RenderBigMenuItem extends React.PureComponent {
  onClick = () => {
    const { getEast, getWest, getNorth, getSouth } = this.props
    const url = `http://fatty.ridewithgps.com?north=${getNorth()}&south=${getSouth()}&east=${getEast()}&west=${getWest()}`
    window.open(url, '_blank')
  }

  render () {
    return <AdminMenuItem
      menuKey={'render_big'}
      label='Render a Big One'
      onClick={() => this.onClick()} />
  }
}
